import { DailyMetricModel } from '@marketplace-web/vas/vas-data'

export const calculateMetricTotals = (metric: Array<Omit<DailyMetricModel, 'date'>>) => {
  return metric.reduce((prev, current) => ({
    organic: prev.organic + current.organic,
    promoted: prev.promoted + current.promoted,
  }))
}
